<nz-layout class="app-layout">
  <nz-sider class="menu-sidebar" nzWidth="250px" nzCollapsible [(nzCollapsed)]="isCollapsed" [nzTrigger]="null"
    style="height: 100vh;">
    <div class="sidebar-logo">
      <a>
        <img src="../../../assets/logo-PA.png" alt="logo" />
        <h1>Planet'ACT</h1>
      </a>
    </div>
    <ul nz-menu nzTheme="light" nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <li nz-menu-item routerLink="/index/customer" routerLinkActive="ant-menu-item-selected">
        <span nz-icon class="menu-icon"><i class="ri-community-line ri-lg"></i></span>
        <span>Établissements</span>
      </li>
      <li nz-menu-item routerLink="/index/balancesheet" routerLinkActive="ant-menu-item-selected">
        <span nz-icon class="menu-icon"><i class="ri-leaf-line ri-lg"></i></span>
        <span>Bilans</span>
      </li>
      <li nz-menu-item routerLink="/index/notifications" routerLinkActive="ant-menu-item-selected">
        <span nz-icon class="menu-icon"><i class="ri-notification-3-line ri-lg"></i></span>
        <span>Notifications</span>
        <nz-badge *ngIf="unreadNotificationsCount > 0" [nzCount]="unreadNotificationsCount" nzStandalone></nz-badge>
      </li>
      <li nz-menu-item routerLink="/index/my-item" *ngIf="!isAdmin" routerLinkActive="ant-menu-item-selected">
        <span nz-icon class="menu-icon"><i class="ri-file-list-line ri-lg"></i></span>
        <span>Mes Items</span>
      </li>
      <li nz-menu-item routerLink="/index/my-lever" *ngIf="!isAdmin" routerLinkActive="ant-menu-item-selected">
        <span nz-icon class="menu-icon"><i class="ri-file-list-3-line ri-lg"></i></span>
        <span>Mes Leviers</span>
      </li>
      <li nz-submenu class="submenu" nzOpen nzTitle="Administration" nzIcon="setting" *ngIf="isAdmin">
        <ul>
          <li nz-menu-item routerLink="/index/category" routerLinkActive="ant-menu-item-selected">Catégories</li>

          <li nz-menu-item routerLink="/index/item" routerLinkActive="ant-menu-item-selected">Items</li>

          <li nz-menu-item routerLink="/index/lever" routerLinkActive="ant-menu-item-selected">Leviers</li>

          <li nz-menu-item routerLink="/index/performance" routerLinkActive="ant-menu-item-selected">Prestations</li>
        </ul>
      </li>
      <li nz-submenu class="submenu" nzOpen nzTitle="Paramétrage" nzIcon="control" *ngIf="isAdmin">
        <ul>
          <li nz-menu-item routerLink="/index/poste" routerLinkActive="ant-menu-item-selected">Postes</li>
          <li nz-menu-item routerLink="/index/unit" routerLinkActive="ant-menu-item-selected">Unités</li>
          <li nz-menu-item routerLink="/index/equivalence-criteria" routerLinkActive="ant-menu-item-selected">Critères
            d'équivalences</li>
          <li nz-menu-item routerLink="/index/affiliate" routerLinkActive="ant-menu-item-selected">Filiales</li>
          <li nz-menu-item routerLink="/index/utilisateur" routerLinkActive="ant-menu-item-selected">Utilisateurs</li>
        </ul>
      </li>
    </ul>
    <div class="app-version">
      <img class="menu-logo" src="../../../assets/Logo_Elior.png" alt="Logo Elior" title="Logo Elior" />
      <span class="version-text">version : {{ appVersion }}</span>
    </div>
  </nz-sider>
  <nz-layout [ngClass]="{
      'content-layout-collapsed': isCollapsed,
      'content-layout': !isCollapsed
    }">
    <nz-header>
      <div class="app-header">
        <span class="header-trigger" (click)="toggleCollapsed()">
          <span class="trigger" nz-icon [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"></span>
        </span>
        <nz-breadcrumb>
          <ng-container *ngFor="let breadcrumb of breadcrumbs$ | async">
            <nz-breadcrumb-item>
              <a [routerLink]="breadcrumb.url">{{ breadcrumb.label }}</a>
            </nz-breadcrumb-item>
          </ng-container>
        </nz-breadcrumb>
      </div>
      <div class="avatar" *ngIf="isLoggedIn">
        <a nz-dropdown [nzDropdownMenu]="menu" [nzPlacement]="'bottomCenter'">
          <nz-avatar nzSize="large" [nzGap]="2" nzText="{{ userService.generateAvatar() }}"
            [ngStyle]="{ background: '#52c41a' }"></nz-avatar>
        </a>
        <nz-dropdown-menu #menu="nzDropdownMenu">
          <ul nz-menu nzSelectable>
            <li nz-menu-item (click)="logout()">Se déconnecter</li>
          </ul>
        </nz-dropdown-menu>
      </div>
    </nz-header>
    <nz-content class="main-content">
      <router-outlet></router-outlet>
    </nz-content>
  </nz-layout>
</nz-layout>